import React from "react";
import "./photoalbum.css";

const PhotoAlbum = ({ photos }) => {
  const handleImgClick = (photo) => {
    document.getElementById("overlay-img").src = photo;
    document.getElementById("overlay").style.display = "block";
  };

  return (
    <div className="photoalbum">
      {photos.map((photo, index) => {
        return (
          <div key={index} className="photo">
            <img
              src={photo.thumbnail}
              alt="not"
              onClick={() => handleImgClick(photo.src)}
            />
          </div>
        );
      })}
    </div>
  );
};

export default PhotoAlbum;



// WEBPACK FOOTER //
// ./src/components/Photogallery/Photoalbum.jsx